module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/promotiondetails/promotiondetails-grid/promotiondetails-grid.component.css
// module id = ./src/app/hrms/serviceregister/promotiondetails/promotiondetails-grid/promotiondetails-grid.component.css
// module chunks = main